<template>
  <b-card>
    <!-- {{ optionsEngineers }} -->
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="Employee"
            rules="required"
          >
            <b-form-group
              label="Employee"
              label-for="Employee"
            >
              <v-select
                v-model="evaluationFrom.user_id"
                :state="getValidationState(validationContext)"
                :options="optionsEngineers"
                trim
                placeholder="Select Employee"
                :clearable="false"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="certificate category"
            rules="required"
          >
            <b-form-group
              label="certificate category"
              label-for="certificate category"
            >
              <v-select
                v-model="evaluationFrom.certificate_category_id"
                :state="getValidationState(validationContext)"
                :options="optionsCertificateCategory"
                trim
                placeholder="Select Category"
                :clearable="false"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="ce level before"
            rules="required"
          >
            <b-form-group
              label="ce level before"
              label-for="ce level before"
            >
              <v-select
                v-model="evaluationFrom.ce_level_before"
                :state="getValidationState(validationContext)"
                :options="optionsCertificateStatus"
                :reduce="val => val.id"
                multiple
                trim
                placeholder="Select Competence Levels"
                :clearable="true"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >

          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addNewEvaluation()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addNewEvaluation()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      required,
      loader: false,
      errors: {},
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    const evaluationFrom = ref({})
    return {
      getValidationState,
      evaluationFrom,
    }
  },
  computed: {
    optionsEngineers() {
      return this.$store.getters['generalData/engineersList/engineersList']
    },
    optionsCertificateCategory() {
      return this.$store.getters['generalData/certificateCategories/certificateCategories']
    },
    optionsCertificateStatus() {
      const statusData = this.$store.getters['generalData/certificateStatus/certificateStatus']
      return statusData
    },
  },
  async mounted() {
    if (!this.$store.getters['generalData/engineersList/engineersLoaded']) {
      await this.$store.dispatch('generalData/engineersList/fetchEngineersList')
    }
    if (!this.$store.getters['generalData/certificateCategories/certificateCategoriesLoaded']) {
      await this.$store.dispatch('generalData/certificateCategories/fetchCertificateCategories')
    }
    if (!this.$store.getters['generalData/certificateStatus/certificateStatusLoaded']) {
      await this.$store.dispatch('generalData/certificateStatus/fetchCertificateStatus')
    }
  },

  methods: {
    // v-select hands back the whole option object; the API wants the plain id.
    unwrapId(value) {
      if (typeof value !== 'object' || value === null) return value
      return value.value !== undefined ? value.value : value.id
    },

    addNewEvaluation() {
      this.loader = true
      const formData = new FormData()
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in this.evaluationFrom) {
        const field = this.evaluationFrom[key]

        if (field === null || field === undefined) {
          // eslint-disable-next-line no-continue
          continue
        }

        if (Array.isArray(field)) {
          // The competence-level select is `multiple` with :reduce, so this is a plain
          // array of ids. An array has no `.value`, so the old check skipped it and the
          // field was never sent at all -- every new evaluation then fell back to
          // "require training" on the server. Send it as a real array instead.
          const name = key === 'ce_level_before' ? 'ce_levels_before' : key

          field
            .filter(item => item !== null && item !== undefined)
            .forEach(item => {
              formData.append(`${name}[]`, item && item.value !== undefined ? item.value : item)
            })
        } else if (field.value !== undefined) {
          formData.append(key, field.value)
        }
      }

      axios.post('/personnel-evaluation/start', formData).then(res => {
        if (res.status === 200 || res.status === 201) {
          this.$router.push({ name: 'personnel-evaluation-master-list' })
          this.$toasted.show('Created Successfully', {
            position: 'top-center',
            duration: 3000,
          })
        }
      }).catch(error => {
        let msg = 'Failed to start evaluation'
        if (error.response && error.response.data) {
          if (error.response.data.payload) {
            try {
              const decrypted = decryptData(error.response.data.payload)
              if (decrypted && decrypted.message) {
                msg = decrypted.message
              } else if (decrypted && typeof decrypted === 'object') {
                const firstKey = Object.keys(decrypted).find(k => Array.isArray(decrypted[k]))
                if (firstKey) {
                  const [firstError] = decrypted[firstKey]
                  if (firstError) msg = firstError
                }
              }
            } catch (e) {
              msg = error.response.data.message || msg
            }
          } else if (error.response.data.message) {
            msg = error.response.data.message
          }
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: msg,
            icon: 'BellIcon',
            variant: 'error',
          },
        })
      }).finally(() => {
        this.loader = false
      })
    },
  },

}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

</style>
